import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { router } from "./rotas/rotas.js";
import { ProvedorDeSessao } from "./shell/Sessao.js";
import "./estilos.css";

/**
 * Repetir erro transiente com backoff, e NUNCA repetir erro de regra.
 * 4xx é resposta do domínio: repetir só atrasa a mensagem que o usuário
 * precisa ler.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: (tentativa, erro) => {
        const status = (erro as { data?: { httpStatus?: number } })?.data?.httpStatus;
        if (status && status >= 400 && status < 500) return false;
        return tentativa < 3;
      },
      retryDelay: (t) => Math.min(1000 * 2 ** t, 30_000),
    },
  },
});

const raiz = document.getElementById("raiz");
if (raiz) {
  createRoot(raiz).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        {/* Nada do app renderiza antes de a sessão existir: a alternativa é
            a tela piscar dados e sumir com eles quando o 401 chega. */}
        <ProvedorDeSessao>
          <RouterProvider router={router} />
        </ProvedorDeSessao>
      </QueryClientProvider>
    </StrictMode>,
  );
}
